module.exports = __webpack_public_path__ + "img/tutorial-2b-sm.7e64941c.jpg";